import React from 'react';
import '../App.css';
import Carousel from 'react-bootstrap/Carousel'


            /*<Carousel.Caption>
              <h3>H4H Fundraiser</h3>
              <p>We are organizing this event to raise money for the charity Instruments for Every Child</p>
            </Carousel.Caption>*/

class SubHeader extends React.Component {
    render () {
      return (
          <Carousel>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src={require('../Images/Choir1.jpg')}
              alt="Images/choir1.jpg"
              style={{ width:'100%' }}
              />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src={require('../Images/Choir2.jpg')}
              alt="Second slide"
              style={{ width:'100%' }}
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src={require('../Images/Choir3.jpg')}
              alt="Third slide"
              style={{ width:'100%' }}
            />
          </Carousel.Item>
        </Carousel>
      )
    }
}

export default SubHeader;
